// extracted by mini-css-extract-plugin
export default {"BCDrawer":"BCDrawer_pSHh4","drawerTitle":"drawerTitle_DbN2a"};